import ThomsonReutersIcon from "src/assets/ThomsonReutersIcon.svg?react";
import {
  getDefaultThomsonReutersClearPersonSearch,
  getDefaultThomsonReutersClearBusinessSearch,
  getDefaultThomsonReutersRiskPersonSearch,
  getDefaultThomsonReutersRiskBusinessSearch,
  getDefaultThomsonReutersBusinessReport,
  getDefaultThomsonReutersPersonReport,
} from "src/connections/connectionConfigs/thomsonReuters/thomsonReutersResources";
import { ThomsonReutersTemplate } from "src/connections/connectionConfigs/thomsonReuters/thomsonReutersTemplate";
import { ConnectionConfig } from "src/connections/connectionConfigs/types";

export const THOMSON_REUTERS_CONFIG: ConnectionConfig<"thomson_reuters"> = {
  icon: ThomsonReutersIcon,
  template: ThomsonReutersTemplate,
  description: "Search, reporting and analytics capabilities",
  name: "US | Thomson Reuters",
  resources: {
    thomson_reuters_clear_person_search: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/thomson-reuters-clear#clear-id-confirm-person-search",
      integrationResource: getDefaultThomsonReutersClearPersonSearch,
    },
    thomson_reuters_clear_business_search: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/thomson-reuters-clear#clear-id-confirm-business-search",
      integrationResource: getDefaultThomsonReutersClearBusinessSearch,
    },
    thomson_reuters_risk_person_search: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/thomson-reuters-clear#risk-inform-person-search",
      integrationResource: getDefaultThomsonReutersRiskPersonSearch,
    },
    thomson_reuters_risk_business_search: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/thomson-reuters-clear#risk-inform-business-search",
      integrationResource: getDefaultThomsonReutersRiskBusinessSearch,
    },
    thomson_reuters_person_report: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/thomson-reuters-clear#person-report",
      integrationResource: getDefaultThomsonReutersPersonReport,
    },
    thomson_reuters_business_report: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/thomson-reuters-clear#business-report",
      integrationResource: getDefaultThomsonReutersBusinessReport,
    },
  },
};
